/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import Race from './../Race';

const ABANDONED = 'Abandoned';

/**
 * Component that is used for rendering course schedule
 * @param course
 * @param isAnchorSet
 * @param isScrollable
 * @constructor
 */
const CourseSchedule = ({ course, isAnchorSet, prefTab, isScrollable }) => (
    <div
        className={
            `rh-cardsMatrix__races ${isScrollable ? 'rh-cardsMatrix__races--scrollable' : ''}`
        }
    >
        {
            course.abandoned ?
                <span className="rh-cardsMatrix__races--abandoned">{ABANDONED}</span> :
                course.races.map(race => <Race
                    key={race.id}
                    race={race}
                    isAnchorSet={isAnchorSet}
                    prefTab={prefTab}
                    racecourse={course.name}
                />)
        }
    </div>
);

CourseSchedule.propTypes = {
    course: PropTypes.shape({
        /**
         * Unique id
         */
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]).isRequired,
        /**
         * Is course abandoned
         */
        abandoned: PropTypes.bool.isRequired,
        /**
         * Is Course all Weather
         */
        allWeather: PropTypes.bool.isRequired,
        /**
         * Surface type of AW track
         */
        surfaceType: PropTypes.string.isRequired,
        /**
         * Course colour
         * If there is no colour, there will be no specific class
         */
        colour: PropTypes.number,
        /**
         * Course name
         */
        name: PropTypes.string.isRequired,
        /**
         * Course country code
         */
        countryCode: PropTypes.string.isRequired,
        /**
         * Course meeting url
         */
        meetingUrl: PropTypes.string.isRequired,
        /**
         * Course hashname
         */
        hashName: PropTypes.string.isRequired,
        /**
         * Course type
         */
        meetingTypeCode: PropTypes.string.isRequired,
        /**
         * List of races
         */
        races: PropTypes.arrayOf(
            PropTypes.shape({
                /**
                 * Is race abandoned
                 */
                abandoned: PropTypes.bool.isRequired,
                /**
                 * Race result
                 */
                result: PropTypes.bool.isRequired,
                /**
                 * Race time
                 */
                link: PropTypes.string.isRequired,
                /**
                 * Race title
                 */
                title: PropTypes.string.isRequired,
                /**
                 * Race time
                 */
                time: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number
                ]),
                /**
                 * Race number of runners
                 */
                runners: PropTypes.number.isRequired,
                /**
                 * Has race offers
                 */
                hasRaceOffers: PropTypes.bool.isRequired,
                /**
                 * Is next race
                 */
                isNextRace: PropTypes.bool.isRequired,
                /**
                 * Is next race less than 30 min away
                 */
                isThirthyMinToNextRace: PropTypes.bool.isRequired,
                /**
                 * Is Race started
                 */
                started: PropTypes.bool.isRequired,
            })
        )
    }).isRequired,
    /**
     * Is anchor set to the course
     */
    isAnchorSet: PropTypes.bool.isRequired,
    /**
     * Pref tab fro cards links
     */
    prefTab: PropTypes.string.isRequired,
    isScrollable: PropTypes.bool,
};

CourseSchedule.defaultProps = {
    isScrollable: false
};

export { CourseSchedule as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CourseSchedule/CourseSchedule.js